/**
 * Toast-Wrapper auf Basis von sonner — Sprint-16-Brand (Cream + Editorial).
 *
 * Verwendung:
 *   import { toast } from 'sonner';
 *   toast.success('Property angelegt');
 *   toast.error('Speichern fehlgeschlagen');
 *
 * Mount: einmal in providers/AppProviders.tsx — schon erledigt.
 */
import { Toaster as SonnerToaster } from 'sonner';

export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      theme="light"
      richColors
      closeButton
      duration={4000}
      toastOptions={{
        classNames: {
          toast: 'group bg-card text-ink border-line/50 shadow-card !rounded-md font-sans',
          title: 'font-sans text-[13px] font-semibold',
          description: 'text-ink-soft text-xs',
          actionButton: '!bg-sage !text-white !rounded-md',
          cancelButton: '!bg-card-alt !text-ink-soft !rounded-md',
          success: '!border-sage/40',
          error: '!border-sealwax/40',
        },
      }}
    />
  );
}
